














import { Component, Vue } from 'vue-property-decorator';
import Cognito from "@/authorization/cognito";
import ForgotPasswordInput from "@/components/forgot_password/Input.vue";
import ForgotPasswordConfirm from "@/components/forgot_password/Confirm.vue";
import {mapGetters} from "vuex";
import {CognitoUser} from "amazon-cognito-identity-js";

@Component({
    components: {
        ForgotPasswordInput,
        ForgotPasswordConfirm,
    },
    computed:
        mapGetters({
            progress:'forgotPassword/progress'
        }),
})

export default class ForgotPassword extends Vue {
    email: string | null = null;
    cognito = new Cognito();

    private inputCognitoUser: CognitoUser | null = null;

    public getCognitouser(cognitoUser: CognitoUser) {
        this.inputCognitoUser = cognitoUser;
    }
}
